import { domain } from '../../../../../../modules/data';
import { messages } from './QBooksTaxSwitcherLegacy.messages';

export const discountTypeReference = [
    {
        id: domain.QBooksDiscountType.Percent,
        text: messages.discountTypePercent,
    },
    {
        id: domain.QBooksDiscountType.Amount,
        text: messages.discountTypeAmount,
    },
];

export const basedOnLocationTax: domain.QBooksTaxCode = {
    id: 'basedOnLocationTax',
    text: messages.basedOnLocation,
    taxRateList: [],
    salesTaxRateList: [],
};
